import { useContext, useEffect, useState } from "react";
import BarChartFleet from "./Barchart/Barchartfleet";
import LineChartFleet from "./LineChart/Fleetlinechart";
import {
  fetchBarchatMonthData,
  fetchBarchatDayData,
  fetchLinehatSpeedMonthData,
  fetchLinechatSpeedDayData,
  fetchLinehatMileageMonthData,
  fetchLinechatMileagDayData,
} from "./LineChart/kpi";
import { FilterContext } from "../../context/Filter";

export default function BarAndLine() {
  const [barMonths, setBarMonths] = useState("month");
  const [lineMonths, setLineMonths] = useState("month");

  const [lineChartMileageMonthData, setLineChartMileageMonthData] = useState(
    []
  );

  const [loading, setLoading] = useState(true);
  const [lineChartSpeedMonthData, setLineChartSpeedMonthData] = useState([]);
  const [barChartData, setBarChartData] = useState([]);
  const { superArn: parArn, childArn, isFilterReady, open } = useContext(FilterContext);

  const fetchBarchatMonthDataAPI = async (parArn, childArn) => {
    try {
      setLoading(true);
      const apiData = await fetchBarchatMonthData(parArn, childArn);

      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      setBarChartData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setBarChartData([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchBarchatDayDataAPI = async (parArn, childArn) => {
    try {
      setLoading(true);
      const apiData = await fetchBarchatDayData(parArn, childArn);

      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      setBarChartData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setBarChartData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchLinehatSpeedMonthDataAPI = async (parArn, childArn) => {
    try {
      setLoading(true);
      const apiData = await fetchLinehatSpeedMonthData(parArn, childArn);

      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }

      setLineChartSpeedMonthData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setBarChartData([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchLinechatSpeedDayDataAPI = async (parArn, childArn) => {
    try {
      setLoading(true);
      const apiData = await fetchLinechatSpeedDayData(parArn, childArn);

      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      setLineChartSpeedMonthData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setBarChartData([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchLineChartMileageMonthDataAPI = async (parArn, childArn) => {
    try {
      setLoading(true);
      const apiData = await fetchLinehatMileageMonthData(parArn, childArn);

      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      setLineChartMileageMonthData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setLineChartMileageMonthData([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchLinechatMileagDayDataAPI = async (parArn, childArn) => {
    try {
      setLoading(true);
      const apiData = await fetchLinechatMileagDayData(parArn, childArn);

      if (!apiData) {
        console.error("API response is empty or invalid:", apiData);
        return;
      }
      setLineChartMileageMonthData(apiData);
    } catch (error) {
      console.error("Error fetching complaint data:", error);
      setLineChartMileageMonthData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isFilterReady) return;
    // const urlParams = new URLSearchParams(window.location.search);
    // const parArn = urlParams.get("arn");
    // const childArn = urlParams.get("childArn");
    fetchBarchatMonthDataAPI(parArn, childArn);
    fetchLinehatSpeedMonthDataAPI(parArn, childArn);
    fetchLineChartMileageMonthDataAPI(parArn, childArn);
  }, [parArn, childArn, isFilterReady]);

  function handleBarSlct(e) {
    const selectedValue = e.target.value;
    setBarMonths(selectedValue);

    // const urlParams = new URLSearchParams(window.location.search);
    // const parArn = urlParams.get("arn");
    // const childArn = urlParams.get("childArn");

    if (selectedValue === "month") {
      fetchBarchatMonthDataAPI(parArn, childArn);
    } else if (selectedValue === "day") {
      fetchBarchatDayDataAPI(parArn, childArn);
    }
  }
  //Line Chart Data
  function handleLineSlct(e) {
    const selectedValue = e.target.value;
    setLineMonths(selectedValue);

    // const urlParams = new URLSearchParams(window.location.search);
    // const parArn = urlParams.get("arn");
    // const childArn = urlParams.get("childArn");

    if (selectedValue === "month") {
      fetchLinehatSpeedMonthDataAPI(parArn, childArn);
      fetchLineChartMileageMonthDataAPI(parArn, childArn);
    } else if (selectedValue === "day") {
      fetchLinechatSpeedDayDataAPI(parArn, childArn);
      fetchLinechatMileagDayDataAPI(parArn, childArn);
    }
  }
  if (!isFilterReady) {
    <p>Loading...</p>;
  }
  return (
    <section className={` ${open ? 'w-[1020px]' : ''} m-1 block sm:flex lg:flex gap-2 `}>
      <div className="  sm:w-1/2 lg:w-1/2 ">
        <header className={hdr} style={sdw}>
          <div className="" />
          <div className="flex justify-between m-1">


            <h6 className={h6}>Mileage</h6>
            <div>

              <select onChange={handleBarSlct} className={slct}>
                <option value="month">Month</option>
                <option value="day">Day</option>
              </select>          </div>                    </div>


        </header>
        <div className="border">
          {loading ? (
            <div className="p-4 text-center">Loading chart data...</div>
          ) : (
            <BarChartFleet barChartData={barChartData} barMonths={barMonths} />
          )}
        </div>
      </div>

      <div className="  sm:w-1/2 lg:w-1/2">
        <header className={hdr} style={sdw}>
          <div />
          <div className=" flex justify-between">

            <h6 className={h6}>Vehicle Utilization</h6>
            <div>

              <select onChange={handleLineSlct} className={slct}>
                <option value="month">Month</option>
                <option value="day">Day</option>
              </select>
            </div>            </div>


        </header>
        <div className="border ">
          {loading ? (
            <div className="p-4 text-center">Loading chart data...</div>
          ) : (
            <LineChartFleet
              lineChartSpeedMonthData={lineChartSpeedMonthData}
              lineChartMileageMonthData={lineChartMileageMonthData}
              lineMonths={lineMonths}
            />
          )}
        </div>
      </div>
    </section>
  );
}

// Styles
const sdw = { boxShadow: "0 0 2px 2px rgba(0, 0, 0, 0.2)" };
const hdr = " p-1 text-white bg-[#056DB3] rounded-t-md";
// const con = "block md:flex flex-col  w-full md:w-1/2";
const slct = "px-2 text-black rounded-t-md";
const h6 = "font-bold text-md  pl-2";
